import { NormalCode } from './../../../../shared/utils/normalCode';
import { PublicHttpService } from './../../../teacher/public-http.service';
import { Component, OnInit, Injector } from '@angular/core';
import * as publicMethods from './../../../../shared/utils/publicMethods';
import { Router } from '@angular/router';
import { WdpjService } from 'src/app/routes/teacher/pjgl/jspj/wdpj.service';
import { FindAllPjpcResp } from 'src/app/routes/teacher/pjgl/entity/findAllPjpcResp';
import { pjglUrls } from '@shared/urls/pjglUrls';
import { Base64 } from 'js-base64';

@Component({
    selector: 'app-wdpj',
    templateUrl: './wdpj.component.html',
    styles: [],
})
export class WdpjComponent extends PublicHttpService implements OnInit {

    pjpcs: Array<FindAllPjpcResp> = [];
    pjzts: Array<any> = [
        { openid: '', name: '全部' },
        { openid: 0, name: '待评教' },
        { openid: 1, name: '已评教' },
    ];
    tableDatas: Array<any> = [];
    params: any = {
        zhsz: 0,
        isPjsj: false,
        pjpcid: '',
        pjpcName: '',
        starttime: '',
        endtime: '',
        xm: '',
        pjztid: '',
        loading: false,
        total: 0,
        page: 1,
        rows: 30,
    }

    constructor(protected injector: Injector, private router: Router, private wdpjService: WdpjService) {
        super(injector);
    }

    // 开始编辑
    startEdit(data: any, isModify: boolean): void {
        const par = {
            bpjrid: data.bpjrid,
            pjpcName: this.params.pjpcName,
            pjsj: this.params.starttime + "~" + this.params.endtime,
            kcName: data.kcName,
            kch: data.kch,
            pjlxName: '',
            bpjrXm: data.xm,
            bpjrGh: data.gh,
            bpjrDeptName: data.deptName,
            hdzf: data.pjzf,
            homePath: 'student/wdpj.html',
            isModify
        };
        this.router.navigate([`pjgl/modifywdpj`, Base64.encodeURI(JSON.stringify(par))]);
    }

    // 分页查询列表
    findPage(): void {
        if (!this.params.pjpcid) {
            this.message.warning('请选择评教批次！');
            return;
        }
        const par = publicMethods.generateFormData({
            pjpcid: this.params.pjpcid,
            pjzt: this.params.pjztid,
            xm: this.params.xm,
            page: this.params.page,
            rows: this.params.rows,
        });
        this.params.loading = true;
        this.http.post(pjglUrls.xsjsPjUrls.findPageBpjr, par)
            .subscribe((res: any) => {
                this.params.loading = false;
                if (res.err_msg) {
                    this.message.error(res.err_msg);
                    return;
                }
                if ((this.params.page - 1) * this.params.rows > res.total) {
                    this.params.page = 1;
                    this.findPage();
                }
                this.tableDatas = res.rows;
                this.params.total = res.total;
            });
    }

    /**
     * 清除查询条件
     */
    clearParams(): void {
        this.params.pjpcid = '';
        this.params.pjztid = '';
        this.params.xm = '';
        this.params.page = 1;
        this.params.rows = 30;
        this.findPage();
    }

    // 评教批次更改事件
    pjpcChange(pjpcid: string): void {
        this.pjpcs.forEach((pjpc: FindAllPjpcResp) => {
            if (pjpc.openid === pjpcid) {
                this.params.pjpcid = pjpc.openid;
                this.params.pjpcName = pjpc.name;
                this.params.starttime = pjpc.starttime;
                this.params.endtime = pjpc.endtime;
                if (this.checkIsPjsj(pjpc, new Date())) {
                    this.params.isPjsj = true;
                } else {
                    this.params.isPjsj = false;
                }
                this.findPage();
                return;
            }
        });
    }

    // 查询评教批次下拉框
    findAllPjpc(): void {
        this.http.post(pjglUrls.xsjsPjUrls.selectAllPjpc, null)
            .subscribe((res: any) => {
                if (res.err_msg) {
                    this.message.error(res.err_msg);
                } else {
                    this.pjpcs = res;
                    // 优先默认当前时间范围内的评教批次
                    const date = new Date();
                    const arr = [];
                    this.pjpcs.forEach((pjpc: FindAllPjpcResp) => {
                        if (this.checkIsPjsj(pjpc, date)) {
                            arr.push(pjpc);
                        }
                    });
                    if (arr.length > 0) {
                        this.params.isPjsj = true;
                        this.params.pjpcid = arr[0].openid;
                        this.params.pjpcName = arr[0].name;
                        this.params.starttime = arr[0].starttime;
                        this.params.endtime = arr[0].endtime;
                    } else if (this.pjpcs.length > 0) {
                        this.params.isPjsj = false;
                        this.params.pjpcid = this.pjpcs[0].openid;
                        this.params.pjpcName = this.pjpcs[0].name;
                        this.params.starttime = this.pjpcs[0].starttime;
                        this.params.endtime = this.pjpcs[0].endtime;
                    }
                    if (this.params.pjpcid) {
                        this.findPage();
                    }
                }
            });
    }

    /**
     * 检测评教批次是否在评教时间范围内
     * @param pjpc 评教批次信息
     * @param date 要检测的时间
     * @returns true在评教时间范围内，false不在评教时间范围内
     */
    private checkIsPjsj(pjpc: FindAllPjpcResp, date: Date): boolean {
        let starttime = new Date(pjpc.starttime.replace(/-/g, "/")).getTime();
        let endtime = new Date(pjpc.endtime.replace(/-/g, "/")).getTime();
        return starttime <= date.getTime() && date.getTime() <= endtime;
    }

    // 获取评教设置
    getPjsz(): void {
        this.http.post(pjglUrls.pjszUrls.getPjzhsz, null)
            .subscribe((res: any) => {
                if (res.err_code === NormalCode.NORMAL_CODE) {
                    this.params.zhsz = res.entity;
                } else {
                    this.message.error(res.err_msg);
                }
            });
    }

    ngOnInit() {
        this.getPjsz();
        this.findAllPjpc();
        this.wdpjService.evnetBus.subscribe((res: any) => {
            this.findPage();
        });
    }

}
